import React, { useState, useEffect } from 'react';
import { API, carsUrl, authFetch } from '../utils/api';

function BulkCancelUploadPage({showToast,user}){
  var [uploadFiles, setUploadFiles] = useState([]);
  var [uploadResults, setUploadResults] = useState([]);
  var [uploading, setUploading] = useState(false);
  var [dragOver, setDragOver] = useState(false);
  var [uploadProgress, setUploadProgress] = useState({current:0,total:0});
  var [cars, setCars] = useState([]);

  useEffect(function(){
    authFetch(carsUrl(user)).then(function(r){return r.json()}).then(function(d){setCars(d||[])}).catch(function(){});
  },[]);

  // 말소신청 상태 차량 수
  var pendingCars = cars.filter(function(c){return c.status==='말소신청'}).length;

  var allowedFile = function(f){return f.type.startsWith('image/') || f.type==='application/pdf' || /\.(jpg|jpeg|png|gif|bmp|tiff|tif|pdf)$/i.test(f.name)};
  var handleDrop = function(e){
    e.preventDefault();setDragOver(false);
    var files = Array.from(e.dataTransfer.files).filter(allowedFile);
    if(files.length===0){showToast('이미지 또는 PDF 파일만 업로드 가능합니다','err');return;}
    setUploadFiles(function(prev){return prev.concat(files)});
  };
  var handleFileSelect = function(e){
    var files = Array.from(e.target.files).filter(allowedFile);
    setUploadFiles(function(prev){return prev.concat(files)});
    e.target.value='';
  };
  var removeFile = function(idx){setUploadFiles(function(prev){return prev.filter(function(_,i){return i!==idx})});};
  var clearUpload = function(){setUploadFiles([]);setUploadResults([]);setUploadProgress({current:0,total:0});};

  var startBulkUpload = async function(){
    if(uploadFiles.length===0){showToast('파일을 추가하세요','err');return;}
    setUploading(true);
    setUploadResults([]);
    var total = uploadFiles.length;
    setUploadProgress({current:0,total:total});

    // 5개씩 배치로 묶어서 서버에 전송 (Batch Processing)
    var BATCH = 5;
    var allResults = [];
    for(var b=0;b<uploadFiles.length;b+=BATCH){
      var chunk = uploadFiles.slice(b, b+BATCH);
      setUploadProgress({current:Math.min(b+BATCH,total),total:total});
      var fd = new FormData();
      for(var k=0;k<chunk.length;k++){fd.append('files',chunk[k]);}
      try{
        var resp = await authFetch(API+'/bulk-cancel-batch',{method:'POST',body:fd});
        if(resp.status===404){
          // 서버 미지원시 기존 1건씩 방식으로 폴백
          for(var fi=0;fi<chunk.length;fi++){
            var fd2 = new FormData();fd2.append('file',chunk[fi]);
            try{
              var r2 = await authFetch(API+'/bulk-cancel-upload',{method:'POST',body:fd2});
              var d2 = await r2.json();
              allResults.push({fileName:chunk[fi].name,serverFileName:d2.fileName||'',success:!d2.error,matched:d2.matched,car:d2.car||null,extracted:d2.extracted||null,reason:d2.reason||d2.error||''});
            }catch(e2){allResults.push({fileName:chunk[fi].name,success:false,matched:false,reason:'서버 오류'});}
          }
          setUploadResults([].concat(allResults));
          continue;
        }
        var d = await resp.json();
        if(d.results){
          d.results.forEach(function(r){allResults.push(r);});
        }
      }catch(err){
        chunk.forEach(function(f){allResults.push({fileName:f.name,success:false,matched:false,reason:'서버 오류: '+(err.message||'')});});
      }
      // 정렬 보정: 청크가 결과를 적게 돌려줘도(서버 500/누락) allResults 인덱스가 uploadFiles 와 어긋나지 않도록
      //   부족분을 '결과 누락' 플레이스홀더로 채움 → 다른 파일 결과가 밀려서 표시되는 버그 방지.
      var _expected = b + chunk.length;
      while(allResults.length < _expected){
        var _mi = allResults.length;
        allResults.push({fileName:(uploadFiles[_mi]&&uploadFiles[_mi].name)||'',success:false,matched:false,reason:'결과 누락 (서버 응답 부족 — 재업로드 필요)'});
      }
      if(allResults.length > _expected) allResults.length = _expected; // 초과분 방어(서버가 더 보낸 경우)
      setUploadResults([].concat(allResults));
    }
    setUploading(false);
    var matched = allResults.filter(function(r){return r.matched}).length;
    var failed = allResults.filter(function(r){return !r.success}).length;
    var unmatched = allResults.filter(function(r){return r.success&&!r.matched}).length;
    showToast('완료: '+matched+'건 매칭, '+unmatched+'건 미분류, '+failed+'건 실패 (배치 처리)');
    authFetch(carsUrl(user)).then(function(r){return r.json()}).then(function(d2){setCars(d2||[])}).catch(function(){});
  };

  // 수동 매칭 상태
  var [manualInputs, setManualInputs] = useState({});
  var [searchResults, setSearchResults] = useState({});
  var [matchingIdx, setMatchingIdx] = useState(null);

  // 미리보기 + 차량 선택 수동 연결 (OCR 차량번호 오추출 대응) — carNo 입력 대신 문서 보고 직접 차량 선택
  var [manualModal, setManualModal] = useState(null); // {idx, fileName, extracted}
  var [previewUrl, setPreviewUrl] = useState('');
  var [pendingCars, setPendingCars] = useState([]);
  var [carQuery, setCarQuery] = useState('');
  var [linkingCar, setLinkingCar] = useState(false);
  var openManualModal = function(idx){
    var r = uploadResults[idx]; var fn = r && r.fileName;
    if(!fn){showToast('서버 파일명을 찾을 수 없어 미리보기를 열 수 없습니다','err');return;}
    setManualModal({idx:idx, fileName:fn, extracted:(r && r.extracted)||{}}); setPreviewUrl(''); setCarQuery('');
    // 미리보기: 인증 필요 → authFetch blob (<img src>는 헤더 못 실음)
    authFetch(API+'/cancel-agency/unmatched-preview/'+encodeURIComponent(fn)).then(function(res){if(!res.ok)throw new Error('preview');return res.blob()}).then(function(b){setPreviewUrl(URL.createObjectURL(b))}).catch(function(){});
    authFetch(API+'/cancel-agency/pending-cars').then(function(r2){return r2.json()}).then(function(d){setPendingCars(Array.isArray(d)?d:[])}).catch(function(){setPendingCars([])});
  };
  var closeManualModal = function(){ if(previewUrl)try{URL.revokeObjectURL(previewUrl)}catch(e){}; setManualModal(null); setPreviewUrl(''); setPendingCars([]); setCarQuery(''); };
  var linkCar = function(carId){
    if(!manualModal)return; var fn = manualModal.fileName; var idx = manualModal.idx; setLinkingCar(true);
    authFetch(API+'/cancel-agency/manual-match-car',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({carId:carId, fileName:fn})}).then(function(r){return r.json()}).then(function(d){
      setLinkingCar(false);
      if(d.success){
        setUploadResults(function(prev){var u=[].concat(prev); u[idx]={fileName:prev[idx].fileName, success:true, matched:true, car:d.car, extracted:prev[idx].extracted, reason:'수동연결'}; return u;});
        showToast('수동 연결 완료: '+d.car.carNo);
        closeManualModal();
        authFetch(carsUrl(user)).then(function(r){return r.json()}).then(function(d2){setCars(d2||[])}).catch(function(){});
      } else showToast(d.error||'연결 실패','err');
    }).catch(function(){setLinkingCar(false);showToast('서버 오류','err')});
  };

  var handleManualSearch = function(idx, value) {
    setManualInputs(function(prev){var n=Object.assign({},prev);n[idx]=value;return n});
    if(value.length < 2){setSearchResults(function(prev){var n=Object.assign({},prev);n[idx]=[];return n});return;}
    authFetch(API+'/car-search?q='+encodeURIComponent(value)).then(function(r){return r.json()}).then(function(d){
      setSearchResults(function(prev){var n=Object.assign({},prev);n[idx]=d||[];return n});
    }).catch(function(){});
  };

  var submitManualMatch = function(idx, carNo) {
    var serverFn = uploadResults[idx] && uploadResults[idx].serverFileName;
    if(!serverFn){showToast('서버 파일명을 찾을 수 없습니다','err');return;}
    setMatchingIdx(idx);
    authFetch(API+'/manual-match',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({carNo:carNo,fileName:serverFn})}).then(function(r){return r.json()}).then(function(d){
      if(d.success){
        setUploadResults(function(prev){
          var updated=[].concat(prev);
          updated[idx]={fileName:prev[idx].fileName,success:true,matched:true,car:d.car,extracted:prev[idx].extracted,reason:'수동매칭'};
          return updated;
        });
        showToast('수동 매칭 완료: '+d.car.carNo);
        authFetch(carsUrl(user)).then(function(r){return r.json()}).then(function(d2){setCars(d2||[])}).catch(function(){});
      } else {
        showToast(d.error||'매칭 실패','err');
      }
      setMatchingIdx(null);
    }).catch(function(){showToast('서버 오류','err');setMatchingIdx(null);});
  };

  var rMatched = uploadResults.filter(function(r){return r.matched}).length;
  var rUnmatched = uploadResults.filter(function(r){return r.success&&!r.matched}).length;
  var rFailed = uploadResults.filter(function(r){return !r.success}).length;
  var [thumbFilter, setThumbFilter] = useState('all');

  return (
    <div>
      {/* 상단 안내 카드 */}
      <div style={{display:'grid',gridTemplateColumns:'repeat(4,1fr)',gap:12,marginBottom:20}}>
        <div className="stat-card"><div className="stat-icon" style={{background:'#fef3c7'}}>⏳</div><div className="stat-info"><div className="stat-number">{pendingCars}</div><div className="stat-label">말소신청 대기</div></div></div>
        <div className="stat-card"><div className="stat-icon" style={{background:'#eff6ff'}}>📄</div><div className="stat-info"><div className="stat-number">{uploadFiles.length}</div><div className="stat-label">선택된 파일</div></div></div>
        <div className="stat-card"><div className="stat-icon" style={{background:'#dcfce7'}}>✅</div><div className="stat-info"><div className="stat-number">{rMatched}</div><div className="stat-label">매칭 완료</div></div></div>
        <div className="stat-card"><div className="stat-icon" style={{background:'#fef2f2'}}>❌</div><div className="stat-info"><div className="stat-number" style={{color:'#dc2626'}}>{rFailed}</div><div className="stat-label">실패</div></div></div>
      </div>

      {/* 실시간 진행률 요약 (업로드 중 또는 결과 있을 때) */}
      {(uploading || uploadResults.length > 0) && (
        <div style={{background:'#fff',border:'1px solid #e2e8f0',borderRadius:10,padding:'10px 16px',marginBottom:14}}>
          <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:6}}>
            <span style={{fontSize:13,fontWeight:700,color:'#222'}}>전체: {uploadResults.length}건</span>
            <span style={{fontSize:12}}>
              <span style={{color:'#166534',fontWeight:600}}>✅ 성공 {rMatched}</span>
              <span style={{color:'#92400e',fontWeight:600,marginLeft:10}}>⚠️ 미분류 {rUnmatched}</span>
              <span style={{color:'#dc2626',fontWeight:600,marginLeft:10}}>❌ 실패 {rFailed}</span>
              {uploading && <span style={{color:'#6b7280',marginLeft:10}}>⏳ 대기 {uploadFiles.length - uploadResults.length}</span>}
            </span>
          </div>
          <div style={{background:'#e5e7eb',borderRadius:8,height:8,overflow:'hidden'}}>
            <div style={{background:rFailed > 0 ? 'linear-gradient(90deg,#22c55e '+(uploadFiles.length?Math.round(rMatched/uploadFiles.length*100):0)+'%,#f59e0b '+(uploadFiles.length?Math.round((rMatched+rUnmatched)/uploadFiles.length*100):0)+'%,#ef4444 100%)' : '#22c55e',height:'100%',width:(uploadFiles.length?Math.round(uploadResults.length/uploadFiles.length*100):0)+'%',transition:'width 0.3s',borderRadius:8}}></div>
          </div>
        </div>
      )}

      {/* 드래그앤드롭 영역 */}
      <div className="card" style={{padding:0,marginBottom:16}}>
        <div
          onDragOver={function(e){e.preventDefault();setDragOver(true);}}
          onDragLeave={function(){setDragOver(false);}}
          onDrop={handleDrop}
          style={{
            padding:48,textAlign:'center',
            border:dragOver?'3px dashed #3b82f6':'3px dashed #d0d5dd',
            borderRadius:12,margin:16,
            background:dragOver?'#eff6ff':'#fafafa',
            transition:'all 0.2s',cursor:'pointer'
          }}
          onClick={function(){document.getElementById('bulk-file-input').click();}}
        >
          <div style={{fontSize:56,marginBottom:12,opacity:0.5}}>📄</div>
          <div style={{fontSize:18,fontWeight:700,color:'#374151',marginBottom:8}}>말소등록사실증명서 이미지를 드래그하세요</div>
          <div style={{fontSize:14,color:'#6b7280'}}>또는 클릭하여 파일 선택 (100장 이상 한번에 가능)</div>
          <div style={{fontSize:12,color:'#9ca3af',marginTop:12}}>AI가 차량번호/차대번호를 자동으로 읽어 해당 차량 폴더로 분류합니다</div>
          <div style={{fontSize:11,color:'#3b82f6',marginTop:8,fontWeight:600}}>지원 형식: JPG, PNG, GIF, BMP, TIFF, PDF</div>
          <input id="bulk-file-input" type="file" multiple accept="image/*,.pdf,.bmp,.tiff,.tif" style={{display:'none'}} onChange={handleFileSelect}/>
        </div>
      </div>

      {/* 선택된 파일 목록 */}
      {uploadFiles.length>0 && (<div className="card" style={{padding:16,marginBottom:16}}>
        <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:12}}>
          <h3 style={{margin:0}}>선택된 파일 ({uploadFiles.length}개)</h3>
          <div style={{display:'flex',gap:8}}>
            <button className="btn btn-blue" onClick={startBulkUpload} disabled={uploading}>
              {uploading ? ('⏳ 처리중 '+uploadProgress.current+'/'+uploadProgress.total) : '🚀 일괄 업로드 시작 ('+uploadFiles.length+'건)'}
            </button>
            <button className="btn btn-outline" onClick={clearUpload} disabled={uploading}>초기화</button>
          </div>
        </div>
        {/* 진행률 바 */}
        {uploading && (<div style={{marginBottom:12}}>
          <div style={{background:'#e5e7eb',borderRadius:8,height:10,overflow:'hidden'}}>
            <div style={{background:'linear-gradient(90deg,#3b82f6,#2563eb)',height:'100%',width:(uploadProgress.total?Math.round(uploadProgress.current/uploadProgress.total*100):0)+'%',transition:'width 0.3s',borderRadius:8}}></div>
          </div>
          <div style={{fontSize:12,color:'#6b7280',marginTop:6,textAlign:'center',fontWeight:600}}>{uploadProgress.current} / {uploadProgress.total} 처리중... ({uploadProgress.total?Math.round(uploadProgress.current/uploadProgress.total*100):0}%)</div>
        </div>)}
        {/* 필터 버튼 */}
        {uploadResults.length > 0 && (
          <div style={{display:'flex',gap:4,marginBottom:8}}>
            {[['all','전체 '+uploadFiles.length],['matched','✅ 성공 '+rMatched],['unmatched','⚠️ 미분류 '+rUnmatched],['failed','❌ 실패 '+rFailed]].map(function(item){
              var k=item[0],l=item[1],active=thumbFilter===k;
              return <button key={k} onClick={function(){setThumbFilter(k)}} style={{padding:'4px 10px',borderRadius:6,fontSize:11,cursor:'pointer',border:active?'1.5px solid #1B3A5C':'1px solid #d0d5dd',background:active?'#1B3A5C':'#fff',color:active?'#fff':'#666',fontWeight:active?600:400}}>{l}</button>;
            })}
          </div>
        )}
        <div style={{display:'flex',flexWrap:'wrap',gap:6,maxHeight:500,overflowY:'auto',padding:2}}>
          {uploadFiles.map(function(f,i){
            var result = uploadResults[i];
            // 필터 적용
            if (thumbFilter === 'matched' && !(result && result.matched)) return null;
            if (thumbFilter === 'unmatched' && !(result && result.success && !result.matched)) return null;
            if (thumbFilter === 'failed' && !(result && !result.success)) return null;
            var bg = result ? (result.matched ? '#dcfce7' : result.success ? '#fef3c7' : '#fef2f2') : '#f8fafc';
            var icon = result ? (result.matched ? '✅' : result.success ? '⚠️' : '❌') : '📄';
            var borderColor = result && !result.success ? '#fca5a5' : '#e2e8f0';
            var isUnmatchedThumb = result && result.success && !result.matched;
            return(<div key={i} onClick={isUnmatchedThumb?function(){openManualModal(i)}:undefined} title={isUnmatchedThumb?'클릭 → 미리보기 + 수동 연결':''} style={{padding:'5px 8px',background:bg,borderRadius:8,fontSize:11,display:'flex',alignItems:'center',gap:4,border:'1.5px solid '+borderColor,position:'relative',cursor:isUnmatchedThumb?'pointer':'default'}}>
              <span>{icon}</span>
              <span style={{maxWidth:120,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{f.name}</span>
              {result && result.matched && <span style={{color:'#166534',fontWeight:700}}>→ {result.car.carNo}</span>}
              {result && result.success && !result.matched && <span style={{color:'#92400e',fontSize:10,fontWeight:700}}>미분류 🔍</span>}
              {result && !result.success && <span style={{color:'#dc2626',fontSize:10}}>{(result.reason||'').substring(0,15)}</span>}
              {!uploading && !result && <button onClick={function(){removeFile(i)}} style={{background:'none',border:'none',cursor:'pointer',fontSize:12,color:'#94a3b8',padding:0,marginLeft:2}}>x</button>}
            </div>);
          })}
        </div>
      </div>)}

      {/* 결과 리포트 */}
      {uploadResults.length>0 && !uploading && (<div className="card" style={{padding:16}}>
        <h3 style={{margin:'0 0 12px'}}>📊 처리 결과 ({uploadResults.length}건)</h3>
        <div style={{display:'grid',gridTemplateColumns:'repeat(3,1fr)',gap:12,marginBottom:16}}>
          <div style={{padding:16,background:'#dcfce7',borderRadius:8,textAlign:'center'}}>
            <div style={{fontSize:28,fontWeight:700,color:'#166534'}}>{rMatched}</div>
            <div style={{fontSize:12,color:'#166534'}}>✅ 매칭 성공</div>
          </div>
          <div style={{padding:16,background:'#fef3c7',borderRadius:8,textAlign:'center'}}>
            <div style={{fontSize:28,fontWeight:700,color:'#92400e'}}>{rUnmatched}</div>
            <div style={{fontSize:12,color:'#92400e'}}>⚠️ 미분류{rUnmatched>0?' (수동매칭 필요)':''}</div>
          </div>
          <div style={{padding:16,background:'#fef2f2',borderRadius:8,textAlign:'center'}}>
            <div style={{fontSize:28,fontWeight:700,color:'#dc2626'}}>{rFailed}</div>
            <div style={{fontSize:12,color:'#dc2626'}}>❌ 실패</div>
          </div>
        </div>
        <div style={{maxHeight:500,overflowY:'auto'}}>
        <table className="data-table">
          <thead><tr><th>파일명</th><th>결과</th><th>인식 차량번호</th><th>인식 차대번호</th><th>매칭 차량</th><th>수동 매칭</th></tr></thead>
          <tbody>
            {uploadResults.map(function(r,i){
              var isUnmatched = r.success && !r.matched;
              var isCompanyUser = user && (user.role==='업체'||user.role==='대행업체');
              return(
              <tr key={i} style={{background:isUnmatched?'#fffbeb':'transparent'}}>
                <td style={{fontSize:11}}>{r.fileName}</td>
                <td>{r.matched?<span style={{color:'#166534',fontWeight:700}}>✅ 성공</span>:r.success?<span style={{color:'#92400e'}}>⚠️ 미분류</span>:<span style={{color:'#dc2626'}}>❌ 실패</span>}</td>
                <td className="mono">{r.extracted?r.extracted.carNo||'-':'-'}</td>
                <td className="mono" style={{fontSize:10}}>{r.extracted?r.extracted.vin||'-':'-'}</td>
                <td style={{fontWeight:700}}>{r.car?r.car.carNo+(isCompanyUser?'':' ('+r.car.owner+')'):'-'}</td>
                <td style={{minWidth:200}}>
                  {isUnmatched && (<div>
                    <button className="btn btn-sm btn-blue" style={{padding:'5px 10px',fontSize:11,marginBottom:4,width:'100%',justifyContent:'center'}} onClick={function(){openManualModal(i)}}>🔍 미리보기로 차량 선택</button>
                    <div style={{display:'flex',gap:4,alignItems:'center'}}>
                      <input
                        value={manualInputs[i]||''}
                        onChange={function(e){handleManualSearch(i,e.target.value)}}
                        placeholder="차량번호 입력"
                        style={{flex:1,padding:'5px 8px',border:'1px solid #d0d5dd',borderRadius:6,fontSize:12,outline:'none'}}
                        disabled={matchingIdx===i}
                      />
                      <button
                        className="btn btn-sm btn-blue"
                        style={{padding:'5px 10px',fontSize:11,whiteSpace:'nowrap'}}
                        onClick={function(){submitManualMatch(i,manualInputs[i]||'')}}
                        disabled={!manualInputs[i]||matchingIdx===i}
                      >{matchingIdx===i?'⏳':'매칭'}</button>
                    </div>
                    {searchResults[i]&&searchResults[i].length>0&&(<div style={{marginTop:4,border:'1px solid #e2e8f0',borderRadius:6,background:'#fff',maxHeight:100,overflowY:'auto'}}>
                      {searchResults[i].map(function(sr){return(
                        <div key={sr.id} style={{padding:'4px 8px',fontSize:11,cursor:'pointer',borderBottom:'1px solid #f1f5f9',fontWeight:600}} onClick={function(){
                          setManualInputs(function(prev){var n=Object.assign({},prev);n[i]=sr.carNo;return n});
                          setSearchResults(function(prev){var n=Object.assign({},prev);n[i]=[];return n});
                        }} onMouseEnter={function(e){e.currentTarget.style.background='#eff6ff'}} onMouseLeave={function(e){e.currentTarget.style.background='#fff'}}>
                          {sr.carNo}
                        </div>
                      )})}
                    </div>)}
                  </div>)}
                  {r.matched&&r.reason==='수동매칭'&&<span style={{fontSize:11,color:'#3b82f6',fontWeight:600}}>수동 매칭됨</span>}
                </td>
              </tr>);})}
          </tbody>
        </table>
        </div>
      </div>)}

      {/* 비어있을 때 */}
      {uploadFiles.length===0 && uploadResults.length===0 && (
        <div className="card" style={{padding:48,textAlign:'center',color:'#94a3b8'}}>
          <div style={{fontSize:15}}>말소증 이미지를 위 영역에 드래그하거나 클릭하여 업로드하세요.</div>
          <div style={{fontSize:12,marginTop:8}}>AI가 차량번호/차대번호를 자동 인식하여 해당 차량 폴더로 분류합니다.</div>
          <div style={{fontSize:12,marginTop:4,color:'#3b82f6'}}>100장 이상도 한번에 처리 가능합니다.</div>
          <div style={{fontSize:11,marginTop:4,color:'#cbd5e1'}}>파일당 최대 50MB</div>
        </div>
      )}

      {/* 미분류 수동 연결 모달 — 문서 미리보기 + 대기 차량 선택 */}
      {manualModal && (function(){
        var ex = manualModal.extracted||{};
        var q = carQuery.trim().toLowerCase();
        var filtered = pendingCars.filter(function(c){
          if(!q)return true;
          return (c.carNo||'').toLowerCase().indexOf(q)>=0 || (c.vin||'').toLowerCase().indexOf(q)>=0 || (c.owner||'').toLowerCase().indexOf(q)>=0 || (c.companyName||'').toLowerCase().indexOf(q)>=0;
        });
        return(<div style={{position:'fixed',top:0,left:0,right:0,bottom:0,background:'rgba(0,0,0,0.55)',display:'flex',alignItems:'center',justifyContent:'center',zIndex:9999}} onClick={closeManualModal}>
          <div style={{background:'#fff',borderRadius:12,padding:20,width:'min(900px,94vw)',maxHeight:'92vh',overflow:'hidden',display:'flex',flexDirection:'column'}} onClick={function(e){e.stopPropagation()}}>
            <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:12}}>
              <h3 style={{margin:0}}>🔍 미분류 말소증 수동 연결</h3>
              <button onClick={closeManualModal} style={{background:'none',border:'none',fontSize:20,cursor:'pointer',color:'#94a3b8'}}>✕</button>
            </div>
            <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:16,flex:1,minHeight:0}}>
              {/* 좌: 문서 미리보기 */}
              <div style={{border:'1px solid #e5e7eb',borderRadius:8,overflow:'auto',background:'#f8fafc',display:'flex',alignItems:'center',justifyContent:'center',minHeight:300}}>
                {previewUrl ? (manualModal.fileName.toLowerCase().slice(-4)==='.pdf'
                    ? <iframe title="preview" src={previewUrl} style={{width:'100%',height:'100%',minHeight:380,border:'none'}}/>
                    : <img src={previewUrl} alt="말소증" style={{maxWidth:'100%',maxHeight:'70vh',display:'block'}}/>)
                  : <div style={{color:'#94a3b8',fontSize:13}}>미리보기 불러오는 중…</div>}
              </div>
              {/* 우: 차량 선택 */}
              <div style={{display:'flex',flexDirection:'column',minHeight:0}}>
                <div style={{fontSize:12,color:'#64748b',marginBottom:6}}>AI 인식: 차량번호 <b>{ex.carNo||'-'}</b> / 차대번호 <b style={{fontSize:11}}>{ex.vin||'-'}</b> <span style={{color:'#dc2626'}}>(미매칭)</span></div>
                <div style={{fontSize:12,fontWeight:700,color:'#1e3a5f',marginBottom:4}}>대기 차량에서 직접 선택 ({pendingCars.length})</div>
                <input value={carQuery} onChange={function(e){setCarQuery(e.target.value)}} placeholder="차량번호 / 차대번호 / 소유자 / 업체 검색" style={{padding:'7px 10px',border:'1px solid #d0d5dd',borderRadius:6,fontSize:13,marginBottom:8,outline:'none'}}/>
                <div style={{flex:1,overflowY:'auto',border:'1px solid #e5e7eb',borderRadius:8}}>
                  {filtered.length===0 ? <div style={{padding:20,textAlign:'center',color:'#94a3b8',fontSize:12}}>대기 차량 없음</div> :
                    filtered.map(function(c){return(
                    <div key={c.id} style={{display:'flex',justifyContent:'space-between',alignItems:'center',padding:'8px 10px',borderBottom:'1px solid #f1f5f9',fontSize:13}}>
                      <div style={{display:'flex',flexDirection:'column'}}>
                        <span style={{fontWeight:700}}>{c.carNo} <span style={{fontWeight:400,color:'#64748b',fontSize:12}}>{c.carType||''}</span></span>
                        <span style={{fontSize:11,color:'#94a3b8',fontFamily:'monospace'}}>{c.vin?c.vin.slice(-8):''} · {c.owner||''} · {c.companyName||''}</span>
                      </div>
                      <button className="btn btn-sm btn-blue" style={{padding:'5px 12px',fontSize:12,whiteSpace:'nowrap'}} disabled={linkingCar} onClick={function(){linkCar(c.id)}}>{linkingCar?'⏳':'연결'}</button>
                    </div>);})}
                </div>
              </div>
            </div>
          </div>
        </div>);
      })()}

      {/* 수출면장 업로드는 스마트 업로드 페이지로 이동 */}
    </div>
  );
}

// ═══ 수출면장 업로드 컴포넌트 (분리) ═══
function ClearanceUploadSection({showToast,onApplied}){
  var [clFiles, setClFiles] = useState([]);
  var [clUploading, setClUploading] = useState(false);
  var [clResults, setClResults] = useState(null);
  var [clChecked, setClChecked] = useState({});
  var [clApplying, setClApplying] = useState(false);

  var handleClFileSelect = function(e){
    var files = Array.from(e.target.files).filter(function(f){return f.type.startsWith('image/')||f.type==='application/pdf'||/\.(jpg|jpeg|png|gif|pdf)$/i.test(f.name)});
    setClFiles(files);
    e.target.value='';
  };

  var startClearanceUpload = async function(){
    if(clFiles.length===0){showToast('면장 파일을 선택하세요','err');return;}
    setClUploading(true);setClResults(null);setClChecked({});
    try{
      var fd=new FormData();
      clFiles.forEach(function(f){fd.append('files',f)});
      var resp=await authFetch(API+'/documents/clearance-upload',{method:'POST',body:fd});
      var d=await resp.json();
      if(!d.success){showToast(d.error||'업로드 실패','err');setClUploading(false);return;}

      // 첫번째 결과 사용 (보통 면장 1건에 여러 차량)
      var result=d;
      setClResults(result);

      // 매칭된 차량만 기본 체크
      var checks={};
      if(result.vehicles){
        result.vehicles.forEach(function(v,i){
          if(v.matched)checks[i]=true;
        });
      }
      setClChecked(checks);
      var mc=result.matchedCount||0;
      var tc=result.totalVehicles||0;
      showToast('면장 OCR 완료: '+tc+'대 중 '+mc+'대 매칭');
    }catch(err){
      showToast('업로드 실패: '+(err.message||'서버 오류'),'err');
    }
    setClUploading(false);
  };

  var toggleCheck=function(idx){setClChecked(function(prev){var n=Object.assign({},prev);if(n[idx])delete n[idx];else n[idx]=true;return n})};
  var toggleAll=function(){
    if(!clResults||!clResults.vehicles)return;
    var allMatchedChecked=clResults.vehicles.every(function(v,i){return !v.matched||clChecked[i]});
    var n={};
    if(!allMatchedChecked){
      clResults.vehicles.forEach(function(v,i){if(v.matched)n[i]=true});
    }
    setClChecked(n);
  };

  var applyClearance=async function(){
    if(!clResults)return;
    var carIds=[];
    clResults.vehicles.forEach(function(v,i){
      if(clChecked[i]&&v.matched&&v.car){carIds.push(v.car.id)}
    });
    if(carIds.length===0){showToast('적용할 차량을 선택하세요','err');return;}
    setClApplying(true);
    try{
      var resp=await authFetch(API+'/documents/clearance-apply',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({
        exportDecNo:clResults.exportDecNo||'',
        carIds:carIds,
        files:clResults.files||[]
      })});
      var d=await resp.json();
      if(d.success){
        showToast('면장 적용 완료: '+d.applied+'대 면장완료 처리');
        setClFiles([]);setClResults(null);setClChecked({});
        if(onApplied)onApplied();
      }else{
        showToast(d.error||'적용 실패','err');
      }
    }catch(err){
      showToast('적용 실패: '+(err.message||''),'err');
    }
    setClApplying(false);
  };

  var checkedCount=Object.keys(clChecked).length;

  return(<div>
    <h2 style={{fontSize:18,fontWeight:700,color:'#1e3a5f',marginBottom:16}}>📋 수출면장 업로드</h2>

    {/* 업로드 영역 */}
    <div className="card" style={{padding:0,marginBottom:16}}>
      <div style={{padding:32,textAlign:'center',border:'3px dashed #d0d5dd',borderRadius:12,margin:16,background:'#fafafa',cursor:'pointer'}} onClick={function(){document.getElementById('clearance-file-input').click()}}>
        <div style={{fontSize:48,marginBottom:8,opacity:0.5}}>📋</div>
        <div style={{fontSize:16,fontWeight:700,color:'#374151',marginBottom:6}}>수출면장(수출신고필증) 이미지를 선택하세요</div>
        <div style={{fontSize:13,color:'#6b7280'}}>여러 장 선택 가능 (앞장+뒷장)</div>
        <div style={{fontSize:11,color:'#3b82f6',marginTop:8,fontWeight:600}}>AI가 면장번호와 차대번호를 자동 인식합니다</div>
        <input id="clearance-file-input" type="file" multiple accept="image/*,.pdf" style={{display:'none'}} onChange={handleClFileSelect}/>
      </div>
    </div>

    {/* 선택된 파일 + 업로드 버튼 */}
    {clFiles.length>0&&!clResults&&(<div className="card" style={{padding:16,marginBottom:16}}>
      <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:8}}>
        <span style={{fontWeight:700,fontSize:13}}>{clFiles.length}개 파일 선택됨</span>
        <div style={{display:'flex',gap:8}}>
          <button className="btn btn-blue" onClick={startClearanceUpload} disabled={clUploading}>
            {clUploading?'':'📋 '}
            {clUploading?'OCR 분석 중...':'면장 분석 시작'}
          </button>
          <button className="btn btn-outline" onClick={function(){setClFiles([])}}>취소</button>
        </div>
      </div>
      {clUploading&&<div style={{textAlign:'center',padding:20}}>
        <div style={{fontSize:36,marginBottom:8,animation:'spin 1s linear infinite'}}>⏳</div>
        <div style={{fontSize:14,fontWeight:700,color:'#2563eb'}}>OCR 분석 중...</div>
        <div style={{fontSize:12,color:'#6b7280',marginTop:4}}>면장에서 차대번호를 추출하고 있습니다</div>
      </div>}
      <div style={{display:'flex',flexWrap:'wrap',gap:6}}>
        {clFiles.map(function(f,i){return(<span key={i} style={{padding:'4px 10px',background:'#eff6ff',borderRadius:6,fontSize:11,color:'#2563eb',fontWeight:600}}>{f.name}</span>)})}
      </div>
    </div>)}

    {/* 매칭 결과 */}
    {clResults&&clResults.vehicles&&(function(){
      var matchedList=clResults.vehicles.filter(function(v){return v.matched});
      var unmatchedList=clResults.vehicles.filter(function(v){return !v.matched});
      return(<div className="card" style={{padding:16}}>
        {/* 헤더 */}
        <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:12}}>
          <h3 style={{margin:0,fontSize:16}}>수출면장 매칭 결과 <span style={{color:unmatchedList.length>0?'#d97706':'#16a34a',fontSize:14}}>({matchedList.length}/{clResults.vehicles.length}대 성공)</span></h3>
          <div style={{display:'flex',gap:8,alignItems:'center'}}>
            <button className="btn btn-blue" onClick={applyClearance} disabled={clApplying||checkedCount===0}>
              {clApplying?'적용 중...':'선택 적용 ('+checkedCount+'대)'}
            </button>
            <button className="btn btn-outline btn-sm" onClick={function(){setClResults(null);setClFiles([])}}>닫기</button>
          </div>
        </div>

        {/* 수출신고번호 */}
        {clResults.exportDecNo&&<div style={{background:'#eff6ff',padding:'10px 16px',borderRadius:8,marginBottom:14,fontSize:13,display:'flex',alignItems:'center',gap:12}}>
          <span style={{fontWeight:700,color:'#1e3a5f'}}>수출신고번호</span>
          <span style={{fontFamily:'monospace',fontWeight:700,fontSize:15,color:'#1e3a5f',letterSpacing:0.5}}>{clResults.exportDecNo}</span>
        </div>}

        {/* 매칭 성공 목록 */}
        {matchedList.length>0&&<div style={{marginBottom:unmatchedList.length>0?12:0}}>
          {matchedList.map(function(v,mi){
            var idx=clResults.vehicles.indexOf(v);
            return(<div key={idx} style={{display:'flex',alignItems:'center',gap:10,padding:'10px 14px',background:'#f0fdf4',border:'1px solid #bbf7d0',borderRadius:8,marginBottom:6}}>
              <input type="checkbox" checked={!!clChecked[idx]} onChange={function(){toggleCheck(idx)}}/>
              <span style={{fontSize:16}}>✅</span>
              <span style={{fontWeight:700,fontSize:13,color:'#166534'}}>{v.car.carNo}</span>
              <span style={{fontSize:12,color:'#166534'}}>({v.car.carType})</span>
              <span style={{fontSize:11,color:'#6b7280'}}>-</span>
              <span style={{fontFamily:'monospace',fontSize:11,color:'#166534'}}>{v.vin}</span>
              {v.car.status&&<span style={{marginLeft:'auto',padding:'2px 8px',borderRadius:4,fontSize:10,fontWeight:600,background:'#dcfce7',color:'#166534'}}>{v.car.status}</span>}
            </div>);
          })}
        </div>}

        {/* 미매칭 목록 */}
        {unmatchedList.length>0&&<div>
          {unmatchedList.map(function(v,ui){
            var idx=clResults.vehicles.indexOf(v);
            return(<div key={idx} style={{display:'flex',alignItems:'center',gap:10,padding:'10px 14px',background:'#fef2f2',border:'1px solid #fca5a5',borderRadius:8,marginBottom:6}}>
              <span style={{width:18,textAlign:'center',color:'#d1d5db'}}>-</span>
              <span style={{fontSize:16}}>❌</span>
              <span style={{fontFamily:'monospace',fontSize:12,fontWeight:700,color:'#dc2626'}}>{v.vin}</span>
              {v.model&&<span style={{fontSize:12,color:'#dc2626'}}>({v.model})</span>}
              <span style={{fontSize:12,color:'#dc2626',marginLeft:4}}>- 미등록 차량</span>
            </div>);
          })}
        </div>}

        {/* 전체선택 토글 */}
        {matchedList.length>1&&<div style={{marginTop:8,display:'flex',gap:8,alignItems:'center'}}>
          <label style={{fontSize:12,color:'#64748b',cursor:'pointer',display:'flex',alignItems:'center',gap:4}}>
            <input type="checkbox" checked={matchedList.every(function(v){var idx=clResults.vehicles.indexOf(v);return clChecked[idx]})} onChange={toggleAll}/>
            매칭 차량 전체선택
          </label>
          <span style={{fontSize:11,color:'#94a3b8'}}>{checkedCount}대 선택됨</span>
        </div>}
      </div>);
    })()}
  </div>);
}

export default BulkCancelUploadPage;
